import { render, staticRenderFns } from "./ProductLicenseExtend.vue?vue&type=template&id=45addcd6&"
import script from "./ProductLicenseExtend.vue?vue&type=script&lang=js&"
export * from "./ProductLicenseExtend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports